import React from 'react';
import { createRoot } from 'react-dom/client';
import { setupExampleTestHarness } from './testHarness';
import { store } from './store';
import { Provider } from 'react-redux';
import {
    GetActivity,
    subscribe,
} from '../../../lib/common/postmonger/postmongerManager';
import {
    Activity,
    Interaction,
    Schema,
} from '../../../lib/common/custom-activity/eventTypes';
import { DataSelector } from './features/dataSelector/dataSelector';
import {
    updateActivity,
    updateInteraction,
    updateSchema,
} from '../../../lib/client/features/journeyBuilder/journeySlice';

// Set up some testing hooks before we mount the UI
setupExampleTestHarness();

// The store can be updated asynchronously from Journey Builder.
// Attach these here to avoid circular imports between the store and
// the postmonger manager.
function attachGlobalAsyncStoreUpdaters() {
    // Update the store if Journey Builder has already provided our data.
    const currentActivity = GetActivity();
    if (currentActivity) {
        store.dispatch(updateActivity(currentActivity));
    }

    // Subscribe to new updates to keep the store in sync
    subscribe('onActivity', (activity: Activity) => {
        // Update the Redux store
        store.dispatch(updateActivity(activity));
    });

    subscribe('onSchema', (schema: Schema) => {
        // Update the Redux store
        store.dispatch(updateSchema(schema));
    });

    subscribe('onInteraction', (interaction: Interaction) => {
        // Update the Redux store
        store.dispatch(updateInteraction(interaction));
    });
}
attachGlobalAsyncStoreUpdaters();

// Mount the UI
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <DataSelector />
    </Provider>,
);
